import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { HttpClient } from '@angular/common/http';
import { BaseView } from 'src/app/view/base-view';
import { TratamientosApiService } from 'src/app/service/api/tratamientos-api.service';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { build, list, stack } from '@fitogest/reactive-form-builder/utils';
import { environment } from 'src/environments/environment';
import esLocale from '@fullcalendar/core/locales/es';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { RequestButtonTypes } from 'src/app/common/components/request-button/request-button.component';
import moment, { Moment } from 'moment';
import { renderHtml2Canvas } from 'src/app/common/html2-canvas-renderer';
import { TareasApiService } from 'src/app/service/api/tareas-api.service';
import { dialogTratamientoManezLozanoChartsComponent } from './dialog-tratamiento-manez/dialog-tratamiento-manez.component';
import { StorageManager } from 'src/app/common/storage-manager.class';
import tippy from 'tippy.js';

import { FincasModel } from 'src/app/models/form-common/fincas.module';
import type { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { TareasBioModel } from 'src/app/models/tareas/tareas-bio.model';
import { CalendarOptions, EventClickArg, EventInput, EventMountArg } from '@fullcalendar/core';
import { BaseResponseModel } from 'src/app/models/base-response.model';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { DropdownData } from '@fitogest/reactive-form-builder/interfaces';
import { TratamientosControlModel } from 'src/app/models/tratamientos/tratamientos-control.model';
import { applyResponsiveFullCalendarView, getResponsiveFullCalendarOptions } from '../../../../common/fullcalendar-responsive-options';
import { createJsPdf } from 'src/app/common/pdf-document-renderer';

moment.locale('es');
@Component({
    selector: 'app-control-tratamientos',
    standalone: false,
    templateUrl: 'control.component.html',
    styleUrls: ['./control.component.scss']
})
export class TratamientosControlComponent extends BaseView<TratamientosControlModel> implements OnInit, AfterViewInit {

    @ViewChild('dialogTratamientos', { static: false }) dialogTratamientos: dialogTratamientoManezLozanoChartsComponent | undefined;

    @ViewChild('calendar') calendarComponent!: FullCalendarComponent;

    public fincaName = environment.features.fincaName;
    public appName = environment.appName;

    public getRequest: RequestHandler<TratamientosControlModel[]> = this.tratamientosApi.tratamientosControl.GET;
    public deleteRequest: RequestHandler<TratamientosControlModel> = this.tratamientosApi.tratamientosControl.DELETE;
    public getRequestBio: RequestHandler<TareasBioModel[]> = this.tareasApi.bio.GET;
    public pathToForm = 'tratamientos-control-form';
    public menuItemId = 'tratamientos-control';

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public tratamientos: TratamientosControlModel[] = [];
    public tareasBio: TareasBioModel[] = [];
    public tareasBioArray: TareasBioModel[] = [];
    public tareasBioArrayFiltered: TareasBioModel[] = [];
    public tratamientosArray: TratamientosControlModel[] = [];
    public tratamientosAuxArray: TratamientosControlModel[] = [];
    public arrayEvents: TratamientosControlModel[] | TareasBioModel[] = [];
    public tratamientosParaImprimir: TratamientosControlModel[] | TareasBioModel[] = [];
    public showEliminarControl = false;
    public showImprimirControl = false;
    public showDescargarCsv = false;
    public isPrinting = false;
    public controlSeleccionado: TratamientosControlModel | undefined;
    public currentWeek = 0;
    public currentWeekArray: number[] = [];
    public currentDayMatrix: number[][] = [];
    public currentMonthAndYear = '';
    public fincas: DropdownData<FincasModel> = list<FincasModel>(['...', null]);
    public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>();
    public fincaModel: FincasModel = {
        id: '',
        nombre: '',
        superficie: '',
        id_usuario: '',
        id_cliente: 0,
        id_finca: '',
        nombre_cliente: '',
        email: '',
        tiene_datos: true
    };
    public fincaSeleccionada = '';
    public fincasIsLoaded = false;
    loadingTelemetry = true;
    public csvModel: TratamientosControlModel = {};

    public maquinarias: {name: string, value: number | null}[] = [];
    public selectedMaquinariaControl = new FormControl<MaquinariaOption | null>(null);

    public options: CalendarOptions = {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        locale: esLocale,
        ...getResponsiveFullCalendarOptions(),
        windowResize: () => {
            applyResponsiveFullCalendarView(this.calendarComponent);
        },
        eventClick: (event: EventClickArg) => {
            this.irAlEvento(event);
        },
        dateClick: (dataEventClick: DateClickArg) => {
            this.irAlDia(dataEventClick);
        },
        eventDidMount: function (info: EventMountArg) {
            tippy(info.el, {
                content: info.event.extendedProps['description'],
                theme: 'light',
                trigger: 'hover',
                placement: 'top',
                interactive: true
            });
        }
    };
    public months = [
        { name: 'Enero', value: 1 },
        { name: 'Febrero', value: 2 },
        { name: 'Marzo', value: 3 },
        { name: 'Abril', value: 4 },
        { name: 'Mayo', value: 5 },
        { name: 'Junio', value: 6 },
        { name: 'Julio', value: 7 },
        { name: 'Agosto', value: 8 },
        { name: 'Septiembre', value: 9 },
        { name: 'Octubre', value: 10 },
        { name: 'Noviembre', value: 11 },
        { name: 'Diciembre', value: 12 }
    ];
    public years = [
        { name: '2020', value: 2020 },
        { name: '2021', value: 2021 },
        { name: '2022', value: 2022 },
        { name: '2023', value: 2023 },
        { name: '2024', value: 2024 },
        { name: '2025', value: 2025 },
        { name: '2026', value: 2026 },
        { name: '2027', value: 2027 },
        { name: '2028', value: 2028 },
        { name: '2030', value: 2030 }
    ];
    public selectedMonth: MonthYearOption | null = null;
    public selectedYear: MonthYearOption | null = null;
    public selectedDate = new Date();
    public monthControl = new FormControl<MonthYearOption | null>(null);
    public yearControl = new FormControl<MonthYearOption | null>(null);
    public fincaControl = new FormControl<FincasModel | null>(null);
    public dateControl = new FormControl<Date>(new Date(), { nonNullable: true });
    contadorMaquinaria = 0;
    public showFieldHelpButtons = false;

    public toggleFieldHelpButtons(): void {
        this.showFieldHelpButtons = !this.showFieldHelpButtons;
    }

    constructor(
        private tratamientosApi: TratamientosApiService,
        private tareasApi: TareasApiService,
        private fincasApi: FincasApiService,
        private dashboard: DashboardService,
        private router: Router,
        public http: HttpClient
    ) {
        super(dashboard, tratamientosApi.tratamientosControl.GET, tratamientosApi.tratamientosControl.DELETE);
    }

    ngOnInit() {
        this.dashboard.setHeaderTitle('Calendario');
        this.dashboard.setMenuItem(this.menuItemId);

        if (this.appName === 'manezylozano') {
            this.options = {
                plugins: [dayGridPlugin, interactionPlugin],
                locale: esLocale,
                ...getResponsiveFullCalendarOptions(),
                editable: true,
                windowResize: () => {
                    applyResponsiveFullCalendarView(this.calendarComponent);
                },
                eventClick: (event: EventClickArg) => {
                    this.irAlEvento(event);
                },
                dateClick: (dataEventClick: DateClickArg) => {
                    this.irAlDia(dataEventClick);
                },
                datesSet: this.getDataManez.bind(this),
                eventDidMount: function () { }
            };
        } else {
            this.fincaModel = JSON.parse(localStorage.getItem('CURRENT_TC_FINCA') ?? 'null') ?? {};

            stack([
                build(this.fincasApi.fincasGET, this.fincas, 'nombre', true),
                build(this.fincasApi.parcelasGET, this.parcelas, 'nombre', true)
            ]).then(async () => {
                if (this.fincaModel?.id_finca) {
                    const found = this.fincas.values
                        .find(it => it && it.value &&
                            String((it.value as FincasModel).id) === String(this.fincaModel.id_finca)
                        );
                    this.setSelectedFinca(found ? found.value : null);
                }
                this.filterFincas();
                await this.filterTratamientosControl();
                return;
            }).catch(e => {
                console.error('catch en stack: ', e);
            });
        }

        this.selectedMonth = this.getStoredMonthYear('CURRENT_TC_MONTH') ?? this.getCurrentMonthOption();
        this.selectedYear = this.getStoredMonthYear('CURRENT_TC_YEAR') ?? this.getCurrentYearOption();
        this.monthControl.setValue(this.selectedMonth, { emitEvent: false });
        this.yearControl.setValue(this.selectedYear, { emitEvent: false });
        this.syncSelectedDateFromFilters();
        this.dateControl.setValue(this.selectedDate, { emitEvent: false });
        this.getTratamientosControl();

        if (this.appName === 'hernandorena') {
            this.years = [
                { name: '2026', value: 2026 },
                { name: '2025', value: 2025 },
                { name: '2024', value: 2024 },
                { name: '2023', value: 2023 },
                { name: '2022', value: 2022 },
                { name: '2021', value: 2021 },
                { name: '2020', value: 2020 }
            ];
            if (Number(this.selectedMonth?.value) === 11) {
                this.years = [{ name: '2027', value: 2027 }, ...this.years];
            }
        }
    }

    ngAfterViewInit() {
        this.calendarComponent.getApi().gotoDate(this.selectedDate);
        applyResponsiveFullCalendarView(this.calendarComponent);

        const fcView: HTMLCollectionOf<Element> = document.getElementsByClassName('fc-view');

        const fcViewArray = Array.from(fcView);

        for (const e of fcViewArray) {
            e.classList.add('no-zindex');
        }
    }

    getDataManez(event: EventInput) {

        const rol = StorageManager.getUser().rol;
        const idUsuario = StorageManager.getUser().id;



        let month = moment(event.end).format('MM') as unknown as number - 1;

        let year = moment(event.start).format('YYYY') as unknown as number;
        const endYear = moment(event.end).format('YYYY') as unknown as number;

        if (month === 0) {
            month = 12;
        }

        if (year !== endYear && month === 1) {
            year = endYear;
        }

        this.http.get<BaseResponseModel<TratamientosControlModel>>(
            environment.serverUrl +
            'ws/index.php?p1=tratamientos&p2=tratamientos_control_get_date&year='
            + year +
            '&month=' + month +
            '&rol=' + rol +
            '&id_usuario=' + idUsuario
        )
            .pipe(map(response => {
                const data = response.data as TratamientosControlModel[];
                const aux: TratamientosControlModel[] = [];

                data.forEach(it => {
                    aux.push({
                        date: (moment(it.fecha)).format('YYYY-MM-DD'),
                        id_finca: it.id_finca ?? 0,
                        fecha: (moment(it.fecha)).format('DD-MM-YYYY'),
                        id_maquinaria: it.id_maquinaria as string,
                        id_usuario: it.id_usuario as string,
                        id_cliente: it.id_cliente as string,
                        ratio_ha: it.ratio_ha as string,
                        uds_medida: it.uds_medida as string,
                        title: it.observaciones ? it.observaciones : it.imei as string,
                        finca_nombre: it.finca_nombre as string,
                        imei: it.imei as string,
                        observaciones: it.observaciones as string,
                        description: it.observaciones as string
                    });
                });

                this.tratamientosArray = aux;
                this.loadingTelemetry = false;

                if (this.selectedMaquinariaControl.value?.value) {
                    this.arrayEvents = this.tratamientosArray.filter(t => String(t.id_maquinaria) === String(this.selectedMaquinariaControl.value?.value));
                } else {

                    this.arrayEvents = this.removeDuplicates(this.tratamientosArray);
                }


            }), catchError(error => {
                this.loadingTelemetry = false;
                console.error('Error cargando telemetría:', error);
                return of(null);
            })).subscribe();
    }

    removeDuplicates(arr: TratamientosControlModel[]) {
        return arr.filter((item: TratamientosControlModel, index: number) =>
            arr.findIndex((otherItem: TratamientosControlModel) =>
                JSON.stringify(item.imei) ===
                    JSON.stringify(otherItem.imei) &&
                        item.date === otherItem.date &&
                        item.observaciones === otherItem.observaciones
            ) === index);
    }

    fillMaquinarias(values: TratamientosControlModel[]): void {
        this.maquinarias = [];
        if (!values?.length) {
            return;
        }

        // Deduplica por id_maquinaria usando un Map
        const unique = new Map<string, string>();
        for (const element of values) {
            const key = element.id_maquinaria?.toString();
            if (key != null && element.title != null) {
                unique.set(key, element.title as string);
            }
        }

        this.maquinarias = [
            { name: '...', value: null },
            ...Array.from(unique.entries()).map(([key, name]) => ({
                name,
                value: parseInt(key, 10)
            }))
        ];
    }

    filterMaquinaria() {
        const filter = this.selectedMaquinariaControl.value;

        if (filter?.value) {
            this.arrayEvents = this.tratamientosArray.filter(t => t.id_maquinaria === filter.value?.toString());
        } else {
            this.arrayEvents = this.removeDuplicates(this.tratamientosArray);
        }
    }


    public async filterTratamientosControl() {
        this.setSelectedFinca(this.fincaControl.value);
        localStorage.setItem('CURRENT_TC_FINCA', JSON.stringify(this.fincaModel));

        if (this.fincaModel && this.fincaModel.id_finca) {
            this.arrayEvents = this.tratamientosArray.filter(it =>
                String(it.id_finca) === String(this.fincaModel.id_finca)
            );
            this.tareasBioArrayFiltered = this.tareasBioArray.filter(it =>
                String(it.id_finca) === String(this.fincaModel.id_finca)
            );
        } else {
            this.arrayEvents = this.tratamientosArray;
            this.tareasBioArrayFiltered = this.tareasBioArray;
        }

        if (this.appName === 'manezylozano') {
            this.tratamientosAuxArray = [...this.arrayEvents];
            this.fillMaquinarias(this.tratamientosAuxArray);
            if (this.maquinarias.length > 1) {
                this.contadorMaquinaria++;
                if (this.contadorMaquinaria >= 1) {
                    this.loadingTelemetry = false;
                }
            }
            this.loadingTelemetry = false;
        } else {
            this.tareasBioArrayFiltered.forEach(it =>
                (this.arrayEvents as TareasBioModel[]).push(it)
            );
            this.loadingTelemetry = false;
        }
    }

    public filterTareasBio() {
        this.setSelectedFinca(this.fincaControl.value);
        localStorage.setItem('CURRENT_TC_FINCA', JSON.stringify(this.fincaModel));

        if (this.fincaModel && this.fincaModel.id_finca) {
            this.tareasBioArrayFiltered = this.tareasBioArray.filter(it =>
                String(it.id_finca) === String(this.fincaModel.id_finca)
            );
        } else {
            this.tareasBioArrayFiltered = this.tareasBioArray;
        }
    }

    public imprimirControl() {
        this.isPrinting = true;
        setTimeout(async () => {
            await renderHtml2Canvas(document.getElementById('html2canvasDiv') ?? new HTMLElement(), { scale: 2, logging: false }).then(async canvas => {
                const pdf = await createJsPdf('l', 'mm', 'a4');
                const data = canvas.toDataURL('image/jpeg');
                pdf.addImage(data, 'jpg', 0, 0, 290, (canvas.height / (canvas.width / 290)), 'alias', 'FAST');
                pdf.save('CT ' + this.selectedFincaName + ' - ' + this.currentMonthAndYear);

                this.isPrinting = false;
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }, 100);
    }

    public irAlDia(e: DateClickArg) {
        if (this.fincaModel && this.fincaModel.id) {
            this.router.navigate([
                'dashboard',
                'crear-control-tratamiento',
                this.fincaModel.id,
                moment(e.date).format('DD-MM-YYYY')
            ]);
        }
    }

    public irAlEvento(e: EventClickArg) {
        let idControl = e.event._def.publicId;

        if (this.appName === 'manezylozano') {
            idControl = e.event._def.publicId ? e.event._def.publicId : e.event._def.sourceId;
        }

        if (idControl) {
            if (e.event._def.extendedProps['prioridad'] === 'Bio') {
                this.router.navigate(['dashboard', 'editar-bio', idControl, true]);
            }
            else {
                if (this.appName === 'manezylozano') {
                    if (e.event._def.defId != null) {

                        const tratamiento: ControlMaquinarias = {
                            id: e.event._def.defId,
                            fecha: e.event._def.extendedProps['fecha'],
                            date: e.event._def.extendedProps['fecha'],
                            id_usuario: e.event._def.extendedProps['id_usuario'],
                            id_cliente: e.event._def.extendedProps['id_cliente'],
                            id_maquinaria: e.event._def.extendedProps['id_maquinaria'],
                            imei: e.event._def.extendedProps['imei'],
                            ratio_ha: e.event._def.extendedProps['ratio_ha'],
                            uds_medida: e.event._def.extendedProps['uds_medida'],
                            observaciones: e.event._def.extendedProps['observaciones']
                        };

                        this.dialogTratamientos?.opendialogChart(tratamiento);
                    }
                } else {
                    this.router.navigate(['dashboard', 'editar-control-tratamiento', idControl]);
                }
            }
        }
        for (const tratamiento of this.tratamientos) {
            if (tratamiento.id === idControl) {
                this.controlSeleccionado = tratamiento;

                break;
            }
        }
    }

    public crearControl() {
        this.router.navigate(['dashboard', 'crear-control-tratamiento']);
    }

    public editControl(data: TratamientosControlModel) {
        this.router.navigate(['dashboard', 'editar-control-tratamiento', data.id]);
    }

    public showEliminar() {
        this.showEliminarControl = false;

        this.deleteRequest.safePerform(this.controlSeleccionado);
        this.deleteRequest.response(() => {
            if (!this.deleteRequest.hasError) {
                this.getRequest.perform();
            }
        });
    }

    public showImprimir() {
        // Genera dinámicamente los números a mostrar en la tabla que se va a imprimir
        const currentDate = moment(this.selectedDate).startOf('month');
        let firstWeek = moment(currentDate).startOf('month').week();
        const lastWeek = moment(currentDate).endOf('month').week();
        const firstDaysWeekday = moment(currentDate).startOf('month').weekday();

        if ((lastWeek - firstWeek + 1) < 1) {
            firstWeek = 0;
        }

        this.currentWeek = moment(this.selectedDate).startOf('month').week();
        this.currentWeekArray = Array(lastWeek - firstWeek + 1).fill(1).map((_, index) => firstWeek + index);
        this.currentMonthAndYear = moment(this.selectedDate).format('MMMM YYYY').toUpperCase();

        let day1: Moment | number;
        let day7: number;
        let weekCount = 0;

        for (const _week of this.currentWeekArray) {
            day1 = moment(currentDate).subtract(firstDaysWeekday, 'days').add((7 * weekCount), 'days');
            day7 = moment(day1 || {}).add(6, 'days').date();
            day1 = day1.date();


            this.currentDayMatrix[weekCount] = [];

            switch (weekCount) {
            case 0:
                if (day1 !== 1) {
                    const lastDayPrevMonth = moment(currentDate).subtract(1, 'month').daysInMonth();

                    while (day7 !== 0) {
                        this.currentDayMatrix[weekCount]?.unshift(day7--);
                    }

                    const prevDays: number[] = [];
                    let prevDay = lastDayPrevMonth - firstDaysWeekday + 1;
                    for (let i = 0; i < firstDaysWeekday; i++) {
                        prevDays.push((prevDay++));
                    }
                    this.currentDayMatrix[weekCount] = prevDays.concat(this.currentDayMatrix[weekCount] ?? []);
                } else {
                    for (let d = day1; d <= day7; d++) {
                        this.currentDayMatrix[weekCount]?.push(d);
                    }
                }
                break;

            case ((this.currentWeekArray.length === 4) ? this.currentWeekArray.length : (this.currentWeekArray.length - 1)):
                if (day1 !== 25) {
                    let nextDay = 1;
                    const trailingDays: number[] = [];
                    while (day7 !== 0) {
                        trailingDays.push((nextDay++));
                        day7--;
                    }
                    while ((this.currentDayMatrix[weekCount] ?? []).length < 7 - trailingDays.length) {
                        this.currentDayMatrix[weekCount]?.push(day1++);
                    }
                    this.currentDayMatrix[weekCount] = (this.currentDayMatrix[weekCount] ?? []).concat(trailingDays);
                } else {
                    for (let d = day1; d <= day7; d++) {
                        this.currentDayMatrix[weekCount]?.push(d);
                    }
                }
                break;
            default:
                for (let d = day1; d <= day7; d++) {
                    this.currentDayMatrix[weekCount]?.push(d);
                }
                break;
            }

            weekCount++;
        }

        const tratamientosPorDia = new Map<number, TratamientosControlModel | TareasBioModel>();

        this.arrayEvents.forEach((it) => {
            const fecha = moment((it as TratamientosControlModel).start, 'YYYY-MM-DD');
            const esteMes = moment(this.selectedDate).month();
            const esteAnyo = moment(this.selectedDate).year();
            if (fecha.month() === esteMes && fecha.year() === esteAnyo) {
                const dia = parseInt(fecha.format('D'), 10);
                tratamientosPorDia.set(dia, it as unknown as TratamientosControlModel);  // <--
            }
        });

        this.tareasBioArrayFiltered.forEach((it) => {
            const fecha = moment((it as TareasBioModel).start, 'YYYY-MM-DD');
            const esteMes = moment(this.selectedDate).month();
            const esteAnyo = moment(this.selectedDate).year();
            if (fecha.month() === esteMes && fecha.year() === esteAnyo) {
                const dia = parseInt(fecha.format('D'), 10);
                if (!tratamientosPorDia.has(dia)) {
                    tratamientosPorDia.set(dia, it as unknown as TareasBioModel);  // <--
                }
            }
        });

        this.tratamientosParaImprimir = [];
        this.currentDayMatrix.forEach(week => {
            week.forEach(day => {
                if (day && day > 0) {
                    (this.tratamientosParaImprimir as TratamientosControlModel[])[day - 1] =
                        (tratamientosPorDia.get(day) as TratamientosControlModel) ?? null as any;
                }
            });
        });


        const elements = document.getElementsByClassName('ui-dialog-content ui-widget-content');
        setTimeout(() => {
            if (elements[0]) {
                elements[0].scrollTop = 0;
            }
        }, 100);

        this.showImprimirControl = true;
    }


    private getStoredMonthYear(storageKey: string): MonthYearOption | null {
        const stored = JSON.parse(localStorage.getItem(storageKey) || 'null') as MonthYearOption | null;

        return stored && stored.value != null ? stored : null;
    }

    private getCurrentMonthOption(): MonthYearOption | null {
        const currentMonth = new Date().getMonth() + 1;

        return this.months.find(month => month.value === currentMonth) ?? null;
    }

    private getCurrentYearOption(): MonthYearOption | null {
        const currentYear = new Date().getFullYear();

        return this.years.find(year => year.value === currentYear) ?? { name: currentYear.toString(), value: currentYear };
    }

    public get selectedFinca(): FincasModel | null {
        return this.fincaControl.value ?? this.resolveCurrentFinca();
    }

    private resolveCurrentFinca(): FincasModel | null {
        const storedId = this.getFincaCandidateId(this.fincaModel.id_finca ?? this.model.id_finca);

        if (storedId === null) {
            return null;
        }

        return this.fincas.values
            .map(option => option.value ?? null)
            .find(finca => this.matchesFincaId(finca, storedId)) ?? null;
    }

    private getFincaCandidateId(value: unknown): string | number | null {
        if (typeof value === 'string' || typeof value === 'number') {
            return value;
        }

        return null;
    }

    private matchesFincaId(finca: FincasModel | null, selectedId: string | number): boolean {
        if (!finca) {
            return false;
        }

        return String(finca.id ?? '') === String(selectedId) || String(finca.id_finca ?? '') === String(selectedId);
    }

    public get hasSelectedFinca(): boolean {
        return this.selectedFinca !== null;
    }

    public get selectedFincaName(): string {
        return this.selectedFinca?.nombre ?? '';
    }

    private syncSelectedDateFromFilters(): void {
        const day = new Date().getDate();
        const selectedMonthValue = this.selectedMonth?.value ?? new Date().getMonth() + 1;
        const month = selectedMonthValue.toString().padStart(2, '0');
        const year = this.selectedYear?.value ?? new Date().getFullYear();

        this.selectedDate = new Date(`${year}-${month}-${day}`);
    }

    public syncCsvDateWithSelectedFilters(): void {
        this.dateControl.setValue(this.selectedDate, { emitEvent: false });
    }

    private setSelectedFinca(finca: FincasModel | null): void {
        this.fincaControl.setValue(finca, { emitEvent: false });
        this.fincaModel = finca
            ? { ...finca, id_finca: finca.id ?? finca.id_finca ?? '' }
            : {
                id: '',
                nombre: '',
                superficie: '',
                id_usuario: '',
                id_cliente: 0,
                id_finca: '',
                nombre_cliente: '',
                email: '',
                tiene_datos: true
            };
    }

    public showSelectedDate(calendar: FullCalendarComponent) {
        this.selectedMonth = this.monthControl.value;
        this.selectedYear = this.yearControl.value;

        localStorage.setItem('CURRENT_TC_MONTH', JSON.stringify(this.selectedMonth));
        localStorage.setItem('CURRENT_TC_YEAR', JSON.stringify(this.selectedYear));

        if (this.appName === 'hernandorena') {
            const year2027: MonthYearOption = { name: '2027', value: 2027 };
            const isNovember = Number(this.selectedMonth?.value) === 11;
            const already2027 = this.years.some(y => y.value === 2027);

            if (isNovember && !already2027) {
                this.years = [year2027, ...this.years];
            } else if (!isNovember && already2027) {
                this.years = this.years.filter(y => y.value !== 2027);
                if (Number(this.selectedYear?.value) === 2027) {
                    this.selectedYear = { name: '2026', value: 2026 };
                    this.yearControl.setValue(this.selectedYear, { emitEvent: false });
                }
            }
        }

        this.syncSelectedDateFromFilters();
        this.dateControl.setValue(this.selectedDate, { emitEvent: false });
        calendar.getApi().gotoDate(this.selectedDate.getTime());

        this.setSelectedFinca(null);
        this.fincaSeleccionada = '';
        this.model.id_finca = 0;

        this.filterFincas();
    }

    public filterFincas() {
        if (this.selectedYear?.name) {
            this.fincas.filtered = this.fincas.values
                .filter(it => {
                    if (!it.value || !it.value.nombre) {
                        return true;
                    }

                    return (it.value.nombre || '').includes(this.selectedYear?.name ?? '');
                });
        } else {
            this.fincas.filtered = this.fincas.values;
        }

        this.filterTratamientosControl().catch(e => {
            console.error('catch en filterTratamientosControl:', e);
        });
    }

    public openDownloadCsvDialog(): void {
        this.syncCsvDateWithSelectedFilters();
        this.showDescargarCsv = true;
    }

    public downloadCsv(): void {
        const selectedFincaId = this.getSelectedFincaId();

        if (!selectedFincaId) {
            return;
        }

        const csvDate = this.getCsvSelectedDate();
        const csvMonth = moment(csvDate).month();
        const csvYear = moment(csvDate).year();

        const download = this.tratamientos
            .filter(control => String(control.id_finca ?? '') === selectedFincaId)
            .filter(control => this.isSameMonthAndYear(control.fecha, csvMonth, csvYear));

        const biodownload = this.tareasBio
            .filter(control => String(control.id_finca ?? '') === selectedFincaId)
            .filter(control => this.isSameMonthAndYear(control.fecha_receta ?? control.fecha, csvMonth, csvYear));

        const csvContent = this.buildCsvContent(download, biodownload);

        this.downloadCsvContent(csvContent, csvDate);
        this.showDescargarCsv = false;
    }

    private getCsvSelectedDate(): Date {
        const value = this.dateControl.value;

        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            return value;
        }

        return this.selectedDate;
    }

    private getSelectedFincaId(): string {
        const selected = this.selectedFinca;

        return String(selected?.id ?? selected?.id_finca ?? '');
    }

    private isSameMonthAndYear(value: unknown, month: number, year: number): boolean {
        const date = this.parseCsvDate(value);

        return date.isValid() && date.month() === month && date.year() === year;
    }

    private parseCsvDate(value: unknown): Moment {
        if (value instanceof Date) {
            return moment(value);
        }

        if (typeof value === 'number') {
            return moment(value);
        }

        if (typeof value === 'string') {
            return moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true);
        }

        return moment.invalid();
    }

    private buildCsvContent(download: TratamientosControlModel[], biodownload: TareasBioModel[]): string {
        const rows: unknown[][] = [
            this.getClientCsvHeader(),
            ...download.map(control => this.getTratamientoCsvRow(control)),
            ...biodownload.map(control => this.getBioCsvRow(control))
        ];

        return rows.map(row => row.map(value => this.csvCell(value)).join(';')).join('\n') + '\n';
    }

    private getClientCsvHeader(): string[] {
        return [
            'Tipo de registro',
            'Tipo de tarea aplicada',
            this.fincaName,
            'Parcelas',
            'Fecha prevista',
            'Fecha aplicación',
            'Estado',
            'Objetivo / plaga',
            'Producto 1',
            'Producto 2',
            'Producto 3',
            'Dosis general',
            'Forma aplicación',
            'Cultivo',
            'Variedad',
            'Superficie cultivada',
            'M2',
            'Sector / agrupación',
            'Suelta/m2',
            'Cantidad total producto',
            'Observaciones'
        ];
    }

    private getTratamientoCsvRow(control: TratamientosControlModel): unknown[] {
        return [
            'Tratamiento control',
            this.getTratamientoTaskType(control),
            this.getFincaName(control.id_finca, control.finca_nombre),
            this.getParcelasNames(control.ids_parcelas),
            this.formatCsvDate(control.fecha),
            this.formatCsvDate(control.fecha),
            control.estado,
            control.plagas,
            this.getProductLine(control.producto1, control.dosis1, control.riqueza1, control.dosis_cuaderno1),
            this.getProductLine(control.producto2, control.dosis2, control.riqueza2, control.dosis_cuaderno2),
            this.getProductLine(control.producto3, control.dosis3, control.riqueza3, control.dosis_cuaderno3),
            control.dosis,
            '',
            control.cultivo,
            control.variedad,
            control.sup_cultivada,
            '',
            '',
            '',
            '',
            control.observaciones
        ];
    }

    private getBioCsvRow(control: TareasBioModel): unknown[] {
        return [
            'Bio',
            this.getBioTaskType(control),
            this.getFincaName(control.id_finca, control.finca_nombre),
            this.getBioParcelasNames(control),
            this.formatCsvDate(control.fecha_receta ?? control.fecha),
            this.formatCsvDate(control.fecha_aplicacion),
            control.orden,
            control.modo_accion,
            this.getText(control.producto),
            '',
            '',
            control.dosis,
            control.forma_aplicacion,
            control.cultivo,
            control.variedad,
            control.superficie_cultivada,
            control.m2,
            control.sector,
            control.suelta_m2,
            control.cantidad_total_producto,
            control.observaciones
        ];
    }

    private getTratamientoTaskType(control: TratamientosControlModel): string {
        return this.getFirstText(control.tratamiento_nombre, control.plagas, 'Tratamiento control');
    }

    private getBioTaskType(control: TareasBioModel): string {
        return this.getFirstText(control.nombre, control.modo_accion, control.producto, 'Bio');
    }

    private getFirstText(...values: unknown[]): string {
        for (const value of values) {
            const text = this.getText(value);

            if (text) {
                return text;
            }
        }

        return '';
    }

    private getProductLine(product: unknown, dosis: unknown, riqueza: unknown, dosisCuaderno: unknown): string {
        const parts = [this.getText(product), this.getText(dosis), this.getText(riqueza)].filter(value => value !== '');
        const productLine = parts.join(' ');
        const cuaderno = this.getText(dosisCuaderno);

        if (!cuaderno) {
            return productLine;
        }

        return productLine ? `${productLine} (${cuaderno})` : cuaderno;
    }

    private getFincaName(rawId: unknown, fallback: unknown): string {
        const fallbackText = this.getText(fallback);

        if (fallbackText) {
            return fallbackText;
        }

        const id = this.getEntityId(rawId);
        const found = this.fincas.values.find(item => this.getEntityId(item.value) === id);

        return this.getValidDropdownLabel(found?.label) || id;
    }

    private getBioParcelasNames(control: TareasBioModel): string {
        const parcelaText = this.getText(control.parcela);

        if (parcelaText) {
            return parcelaText;
        }

        return this.getParcelasNames(control.ids_parcelas);
    }

    private getParcelasNames(rawValue: unknown): string {
        const ids = this.getSelectedIds(rawValue);

        if (ids.length === 0) {
            return this.getText(rawValue);
        }

        const labels = ids
            .map(id => this.findParcelaLabel(id))
            .filter((label): label is string => label !== null && label !== '');

        return labels.length > 0 ? labels.join(', ') : ids.join(', ');
    }

    private findParcelaLabel(id: string): string | null {
        const found = this.parcelas.values.find(item => this.getEntityId(item.value) === id);

        return this.getValidDropdownLabel(found?.label);
    }

    private getSelectedIds(rawValue: unknown): string[] {
        if (Array.isArray(rawValue)) {
            return rawValue
                .map(value => this.getEntityId(value))
                .filter(value => value !== '');
        }

        const id = this.getEntityId(rawValue);

        if (id && id !== this.getText(rawValue)) {
            return [id];
        }

        return this.getText(rawValue)
            .split(/[;,]/)
            .map(value => value.trim())
            .filter(value => value !== '');
    }

    private getEntityId(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        if (typeof value !== 'object') {
            return String(value).trim();
        }

        const entity = value as { id?: unknown; id_finca?: unknown; id_parcela?: unknown };

        return this.getFirstText(entity.id, entity.id_finca, entity.id_parcela);
    }

    private getValidDropdownLabel(label: string | undefined): string | null {
        return label && label !== '...' ? label : null;
    }

    private formatCsvDate(value: unknown): string {
        const date = this.parseCsvDate(value);

        return date.isValid() ? date.format('DD/MM/YYYY') : this.getText(value);
    }

    private getText(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        if (value instanceof Date) {
            return moment(value).format('DD/MM/YYYY');
        }

        if (typeof value !== 'object') {
            return String(value).trim();
        }

        const item = value as { nombre?: unknown; name?: unknown; label?: unknown; id?: unknown };

        return this.getFirstText(item.nombre, item.name, item.label, item.id);
    }

    private csvCell(value: unknown): string {
        const text = this.getText(value);

        return `"${text.replace(/"/g, '""')}"`;
    }

    private downloadCsvContent(csvContent: string, csvDate: Date): void {
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (!csvLink) {
            return;
        }

        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const objectUrl = URL.createObjectURL(blob);
        const fincaName = this.sanitizeFileName(String(this.selectedFinca?.nombre ?? 'controles'));

        csvLink.download = `controles_${fincaName}_${moment(csvDate).format('YYYY-MM')}.csv`;
        csvLink.href = objectUrl;
        csvLink.click();
        URL.revokeObjectURL(objectUrl);
    }

    private sanitizeFileName(value: string): string {
        return value
            .trim()
            .replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ_-]+/g, '_')
            .replace(/^_+|_+$/g, '') || 'controles';
    }

    private getTareasBio(): Promise<void> {
        const fechaActual = moment().toDate();

        this.getRequestBio.safePerform();
        return new Promise<void>(resolve => {
            this.getRequestBio.response(res => {
                this.tareasBio = res;
                this.tareasBioArray = this.tareasBio
                    .map((it: TareasBioModel) => {
                        let color = '';
                        const fechaControl = moment(it.fecha_aplicacion as string, ['DD/MM/YYYY', 'YYYY-MM-DD']).toDate();
                        const estado = it.orden;
                        switch (estado) {
                        case 'Planificado':
                            if (fechaControl < fechaActual) {
                                color = '#ff9090';
                            } else {
                                color = '#4184CE';
                            }
                            break;
                        case 'Orden ficha':
                            color = '#FFB13B';
                            break;
                        case 'Aplicado':
                            color = '#256B2A';
                            break;
                        default:
                            color = '#4184CE';
                            break;
                        }

                        let title = '';
                        if (it.producto) { title += it.producto + '-'; }
                        if (it.modo_accion) { title += it.modo_accion + '-'; }
                        if (it.forma_aplicacion) { title += it.forma_aplicacion + '-'; }
                        if (it.cultivo) { title += it.cultivo + '-'; }
                        if (it.variedad) { title += it.variedad + '-'; }

                        return {
                            id: it.id,
                            id_finca: it.id_finca,
                            description: 'tarea bio',
                            title,
                            color,
                            estado,
                            start: moment(it.fecha_receta as string, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD'),
                            dosis1: '',
                            dosis2: '',
                            dosis3: '',
                            finca_nombre: '',
                            observaciones: '',
                            prioridad: 'Bio',
                            producto1: '',
                            producto2: '',
                            producto3: '',
                            riqueza1: '',
                            riqueza2: '',
                            riqueza3: '',
                            tratamiento_nombre: ''
                        };
                    }) as TareasBioModel[];
                resolve();
            });
        });
    }

    private getTratamientosControl() {
        const fechaActual = moment().toDate();

        if (this.appName === 'manezylozano') {
        } else {
            this.getRequest.safePerform();
            new Promise<void>(resolve => {
                this.getRequest.response(res => {
                    this.tratamientos = res;
                    this.tratamientosArray = this.tratamientos
                        .map((it: TratamientosControlModel) => {
                            let color = '';
                            const fechaControl = moment(it.fecha as string, ['YYYY-MM-DD', 'DD/MM/YYYY']).toDate();
                            switch (it.estado) {
                            case 'Planificado':
                                if (fechaControl < fechaActual) {
                                    color = '#ff9090';
                                } else {
                                    color = '#4184CE';
                                }
                                break;
                            case 'Orden ficha':
                                color = '#FFB13B';
                                break;
                            case 'Aplicado':
                                color = '#256B2A';
                                break;
                            default:
                                color = '#4184CE';
                                break;
                            }

                            let title = '';
                            if (it.plagas) { title += it.plagas + '-'; }
                            if (it.producto1) { title += it.producto1 + ' ' + (it.dosis1 || '') + ' ' + (it.riqueza1 || '') + '-'; }
                            if (it.producto2) { title += it.producto2 + ' ' + (it.dosis2 || '') + ' ' + (it.riqueza2 || '') + '-'; }
                            if (it.producto3) { title += it.producto3 + ' ' + (it.dosis3 || '') + ' ' + (it.riqueza3 || '') + '-'; }
                            if (it.observaciones) { title += it.observaciones; }

                            return {
                                id: it.id,
                                id_finca: it.id_finca,
                                title,
                                finca_nombre: it.finca_nombre,
                                tratamiento_nombre: it.tratamiento_nombre,
                                estado: it.estado,
                                prioridad: it.prioridad,
                                start: moment(it.fecha as string, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('YYYY-MM-DD'),
                                color,
                                observaciones: it.observaciones,
                                description: it.observaciones,
                                producto1: it.producto1,
                                producto2: it.producto2,
                                producto3: it.producto3,
                                riqueza1: it.riqueza1,
                                riqueza2: it.riqueza2,
                                riqueza3: it.riqueza3,
                                dosis1: it.dosis1,
                                dosis2: it.dosis2,
                                dosis3: it.dosis3
                            };
                        }) as TratamientosControlModel[];
                    resolve();
                });
            }).then(() => {
                return this.getTareasBio();
            }).then(async () => {
                await this.filterTratamientosControl();
            }).catch(e => {
                console.error('catch en getTratamientosControl:', e);
            });
        }
    }

}

interface MonthYearOption {
    name: string;
    value: number;
}

interface MaquinariaOption {
    name: string;
    value: number | null;
}

interface ControlMaquinarias {
    fecha: string;
    date: string;
    id: string;
    id_cliente: string;
    id_maquinaria: string;
    id_usuario: string;
    imei: string;
    observaciones: string;
    ratio_ha: string;
    uds_medida: string;
    maquinaria?: { imei?: string };
    id_telemetry?: string;

}